
$('ul.tabs li').click(function () {
    $('.tab-content.current').addClass('refreshed');
    var tabId = $(this).attr('data-tab');
    $('#' + tabId).addClass('refreshed');
    $('ul.tabs li').removeClass('current');
    $('.tab-content').removeClass('current');

    $(this).addClass('current');
    $('#' + tabId).addClass('current');
    $('#' + tabId + ' .slick-slider.slick-initialized').slick('setPosition');
});
